import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { HelixPalette } from '../../helix';
const BannerBase = {
    border: '2px solid',
    borderRadius: '8px',
    display: 'flex',
    padding: '1rem 0.75rem',
};
export const ErrorBanner = styled(Box)(() => (Object.assign(Object.assign({}, BannerBase), { backgroundColor: HelixPalette.red05, borderColor: HelixPalette.red60 })));
export const InfoBanner = styled(Box)(() => (Object.assign(Object.assign({}, BannerBase), { backgroundColor: HelixPalette.teal05, borderColor: HelixPalette.teal70 })));
export const SuccessBanner = styled(Box)(() => (Object.assign(Object.assign({}, BannerBase), { backgroundColor: HelixPalette.green05, borderColor: HelixPalette.green90 })));
export const WarningBanner = styled(Box)(() => (Object.assign(Object.assign({}, BannerBase), { backgroundColor: HelixPalette.yellow05, borderColor: HelixPalette.yellow50 })));
